import styled from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { MANUAL_EDIT_BAR_WIDTH } from '../ScenarioGrid.style';

export const LegendRoot = styled.div<{ theme: InterstateTheme }>`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-top: 0.5rem;
    font-size: 14px;
    color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
`;

export const LegendSwatch = styled.span<{ theme: InterstateTheme }>`
    width: ${MANUAL_EDIT_BAR_WIDTH};
    height: 1rem;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.tokens.SemColorBorderCaution};
`;
